<style lang="scss" scoped>
.btn-send {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b8bfc5;
  border-radius: 0;

  &:hover {
    color: $gray-900;
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.disabledbutton {
  pointer-events: none;
  opacity: 0.4;
}
.dialog-buttons {
  display: flex;
}
@media (max-width: 1200px) {
  .dialog-buttons {
    display: flex;
    width: 100%;

    > * {
      flex-grow: 1;
    }
  }
}
</style>
<template>
  <section>
    <modal
      width="80%"
      height="auto"
      :pivot-y="0.1"
      :adaptive="true"
      resizable
      draggable
      scrollable
      name="private-images"
    >
      <private-image-select
        @send-private-image="sendImage($event)"
      ></private-image-select>
    </modal>
    <modal
      width="80%"
      height="auto"
      :pivot-y="0.1"
      :adaptive="true"
      resizable
      scrollable
      name="tenor"
    >
      <tenor-select @send-gif="$emit('send-gif', $event)"></tenor-select>
    </modal>
    <modal
      width="80%"
      height="auto"
      :pivot-y="0.1"
      :adaptive="true"
      scrollable
      name="gift"
    >
      <gift-select @send-gift="$emit('send-gift', $event)"></gift-select>
    </modal>
    <div class="dialog-buttons">
      <emoji-picker
        @select="$emit('add-emoji', $event)"
        v-tooltip:top="'Smileys/Emojis'"
      ></emoji-picker>
      <div v-if="canSendImage">
        <div
          v-if="customer"
          @click="openImageUpload"
          class="btn btn-send"
          v-tooltip:top="imageSendTooltip"
          :class="{ disabledbutton: disabled }"
        >
          <i class="fas fa-image"></i>
          <input
            @change="sendImage($event)"
            class="d-none"
            type="file"
            accept="image/jpeg,image/png,image/gif"
            ref="chat-image-upload"
          />
        </div>
        <div
          v-else
          @click="$modal.show('private-images')"
          class="btn btn-send"
          v-tooltip:top="'Bild senden'"
          :class="{ disabledbutton: disabled }"
        >
          <i class="fas fa-portrait"></i>
        </div>
      </div>
      <div
        @click="$modal.show('gift', $event)"
        class="btn btn-send"
        v-tooltip:top="'Geschenk senden'"
        :class="{ disabledbutton: disabled }"
      >
        <i class="fas fa-gifts"></i>
      </div>
      <div
        @click="$modal.show('tenor')"
        class="btn btn-send"
        v-tooltip:top="gifSendTooltip"
        :class="{ disabledbutton: disabled }"
      >
        gif
      </div>
      <div
        @click="enableSending ? $emit('send-blink', $event) : null"
        class="btn btn-send"
        v-tooltip:top="blinkSendTooltip"
        :class="{ disabledbutton: disabled }"
      >
        <i class="far fa-grin-wink"></i>
      </div>
    </div>
  </section>
</template>
<script>
import TenorSelect from "@/components/TenorSelect.vue";
import GiftSelect from "@/components/GiftSelect.vue";
import PrivateImageSelect from "@/components/PrivateImageSelect.vue";
import EmojiPicker from "@/components/EmojiPicker.vue";

export default {
  components: {
    TenorSelect,
    GiftSelect,
    EmojiPicker,
    PrivateImageSelect
  },
  props: {
    enableSending: {
      required: false,
      type: Boolean,
      default: true
    },
    customer: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    canSendImage: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  computed: {
    imageSendTooltip() {
      let tooltip = "Bild senden";
      return this.customer
        ? `${tooltip} für ${Laravel.settings.pricePerMedia} ${this.currency}`
        : tooltip;
    },
    blinkSendTooltip() {
      return this.customer
        ? `${Laravel.settings.blinkName} für ${Laravel.settings.pricePerBlink} ${this.currency}`
        : Laravel.settings.blinkName;
    },
    gifSendTooltip() {
      let tooltip = "Gif senden";
      return this.customer
        ? `${tooltip} für ${Laravel.settings.pricePerGif} ${this.currency}`
        : tooltip;
    },
    currency() {
      return Laravel.lang.currency;
    }
  },
  methods: {
    openImageUpload() {
      this.$refs["chat-image-upload"].click();
    },
    sendImage(event) {
      this.$emit("send-image", event);
      if (this.$refs["chat-image-upload"])
        this.$refs["chat-image-upload"].value = "";
    }
  }
};
</script>
